import { validate as isUuid } from 'uuid'

import { isRecord, isValidTimestamp } from '@/utils/eventEnvelope'

const hasValidOrderNumber = assignment => {
    const orderNumber = assignment?.order_num
    if (orderNumber === undefined || orderNumber === null) return true

    if (typeof orderNumber === 'string') return Boolean(orderNumber.trim())

    return typeof orderNumber === 'number' && Number.isFinite(orderNumber)
}

export const normalizeAssignment = assignment => {
    if (
        !isRecord(assignment) ||
        !isUuid(assignment.assignment_id) ||
        !isUuid(assignment.order_id) ||
        !isValidTimestamp(assignment.expires_at) ||
        !hasValidOrderNumber(assignment)
    ) {
        throw new Error('Сервис Play вернул некорректное назначение')
    }

    return assignment
}

const readAssignment = assignment => {
    if (assignment === null || assignment === undefined) return null

    try {
        return normalizeAssignment(assignment)
    } catch (error) {
        console.warn('[WS: Play] Пропущено некорректное назначение', error)
        return null
    }
}

export const normalizePlayState = data => {
    if (
        !isRecord(data) ||
        typeof data.play_enabled !== 'boolean' ||
        !Number.isInteger(data.state_version) ||
        data.state_version < 0
    ) {
        throw new Error('Сервис Play вернул некорректное состояние')
    }

    return {
        enabled: data.play_enabled,
        stateVersion: data.state_version,
        assignment: readAssignment(data.assignment),
    }
}

export const normalizePlayEvent = event => {
    if (!isRecord(event) || !isRecord(event.payload)) {
        throw new Error('Получено некорректное событие Play')
    }

    if (event.type === 'assignment_offered') {
        const assignment = normalizeAssignment(event.payload)
        if (
            !isValidTimestamp(event.payload.issued_at) ||
            !isValidTimestamp(event.payload.server_time)
        ) {
            throw new Error('Получено некорректное предложение Play')
        }
        return { type: event.type, payload: assignment }
    }

    if (event.type === 'assignment_resolved') {
        if (
            !isUuid(event.payload.assignment_id) ||
            !isUuid(event.payload.order_id) ||
            !['accepted', 'declined', 'expired'].includes(
                event.payload.resolution
            )
        ) {
            throw new Error('Получено некорректное завершение Play')
        }
        return event
    }

    if (event.type === 'play_state') {
        if (
            typeof event.payload.play_enabled !== 'boolean' ||
            !Number.isInteger(event.payload.state_version) ||
            event.payload.state_version < 0 ||
            !['manual', 'auto_stop'].includes(event.payload.reason)
        ) {
            throw new Error('Получено некорректное состояние Play')
        }
        return event
    }

    throw new Error('Получен неизвестный тип события Play')
}
